import React, { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import CircularProgress from "@mui/material/CircularProgress";
import { FiEdit } from "react-icons/fi";
import profile from "../assets/images/userprofile/profile.png";
import { MatchEditProfile } from "./matchmakerEditprofile/matchEditProfile";
import { MatchmakerAddProfile } from "./matchmakerAddprofle/matchmakerAdd";
import { MatchProfileUpload } from "./matchmakerProfleUpload/matchProfileupload";
import imagePlaceholder from "../assets/images/userprofile/imagePlaceholder.jpg";
import imagePlaceholder1 from "../assets/images/userprofile/logo_nathi_profile_log99.png";
import { axiosInstance_agent } from "../axiosInstance-agent";
import { Link, useNavigate } from "react-router-dom";
import { MdOutlineDeleteOutline } from "react-icons/md";
import Modal from "react-bootstrap/Modal";
import { ToastContainer, toast } from "react-toastify";
import Preloader from "../Components/Preloader";
import { IoEyeOutline } from "react-icons/io5";

const columns = [
  { id: "userid", label: "User ID", minWidth: 170, align: "center" },
  { id: "name", label: "Name", minWidth: 100, align: "center" },
  {
    id: "mobile",
    label: "Mobile",
    minWidth: 170,
    align: "center",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 170,
    align: "center",
  },
  {
    id: "plan",
    label: "Plan Type",
    minWidth: 170,
    align: "center",
  },
  {
    id: "profileuploaded",
    label: "Profiles Uploaded",
    minWidth: 170,
    align: "center",
  },
  {
    id: "actions",
    label: "Actions",
    minWidth: 170,
    align: "center",
  },
];

function createData(
  profileImg,
  userid,
  name,
  mobile,
  email,
  plan,
  profileuploaded
) {
  return {
    profileImg,
    userid,
    name,
    mobile,
    email,
    plan,
    profileuploaded,
    actions: <FiEdit />,
  };
}

export function Matchmakers() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [userData, setuserData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [deleteId, setDeleteId] = useState();
  const navigate = useNavigate();
  //delete modal state
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = (id) => {
    setShow(true);
    setDeleteId(id);
  };

  console.log("data:", userData);

  // const handleuserData = (query = "") => {
  //   setLoading(true);
  //   axiosInstance_agent
  //     .get(`/matchmaker?search=${query}`)

  //     .then((response) => {
  //       const users = response.data?.data || [];
  //       setuserData(users);
  //       setLoading(false);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching users:", error);
  //       setLoading(false);
  //     });
  // };
  // useEffect(() => {
  //   handleuserData();
  // }, []);

  async function handleUserData() {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get("/matchmaker");
      const users = response.data?.data || [];
      setuserData(users);
    } catch (error) {
      console.error("Error fetching Matchmakers:", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    handleUserData();
  }, []);
  function handleSearch(e) {
    const value = e.target.value;
    setSearchQuery(value);
  }
  async function FetchSearchDetails() {
    const config = {
      params: {
        search: searchQuery,
      },
    };
    try {
      setLoading(true);
      const response = await axiosInstance_agent.get("/matchmaker", config);
      if (response.status === 200 || response.data.status === "success") {
        setuserData(response.data.data);
      }
    } catch (error) {
      console.error("Error fetching Matchmakers:", error);
      // toast.error("Unable to fetch contact lists");
    } finally {
      setLoading(false);
    }
  }

  function handleReset() {
    setSearchQuery("");
    handleUserData();
  }

  // Trigger API call when searchQuery changes (debounced)
  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     handleuserData(searchQuery);
  //   }, 100);

  //   return () => clearTimeout(delayDebounce);
  // }, [searchQuery]);
  async function handleDeleteUser(id) {
    try {
      setLoading(true);
      const response = await axiosInstance_agent.delete(`/photographer/${id}`);
      if (response.data.status === true || response.status === 200) {
        console.log("response", response.data);
        toast.success(response.data.message || "profile deleted successfully!");
        handleUserData();
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to delete!");
      console.log("Failed to fetch users");
    } finally {
      setLoading(false);
    }
  }
  const rows =
    userData?.map((match) => ({
      userid: match?.id ? `XXX${String(match.id).slice(-1)}` : "--",
      originalId: match?.id || "--",
      // profileImg: match.profile_pic?.profile_pic || imagePlaceholder1,
      profileImg: match.profile_pic || imagePlaceholder1,
      name: match.full_name || "--",
      mobile: match.mobile || "--",
      email: match.email || "--",
      plan: match.plan || "---",  // Original type
      planDisplay: match.plan === "Recommended" ? "Standard" : match.plan || "---", // For table
      public_token: match.public_token || null,
      profileuploaded: match.profiles_count || "--",
      biodata_set: match.biodata_set || [],
      full_name: match.full_name || "--",
    })) || [];

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
    <>
      {loading && <Preloader />}
      <ToastContainer />
      <div className="userProfile-container">
        <div className="userProfile-content">
          <div className="userProfile-title">
            Total User’s : {userData?.length || 0}
          </div>
          <div className="search-container">
            <div className="searchBar">
              <span>
                <input
                  type="text"
                  placeholder="Search by name or email or mobile No."
                  value={searchQuery}
                  onChange={handleSearch}
                />
              </span>
              <div>
                <span
                  className="bi bi-search search me-2"
                  style={{ cursor: "pointer" }}
                  onClick={() => FetchSearchDetails()}
                ></span>
                <span
                  style={{ color: "#F24464", cursor: "pointer" }}
                  onClick={() => handleReset()}
                >
                  Reset
                </span>
              </div>
            </div>
          </div>
          <div>
            <Link to="/matchmaker-add-profile">
              <button className="btnAdd">+ Add Profile</button>
            </Link>
          </div>
        </div>
        {/* table data */}
        <Paper sx={{ width: "100%", overflow: "hidden" }}>
          <TableContainer sx={{ maxHeight: 440 }} className="table-container">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.align}
                      style={{ minWidth: column.minWidth }}
                      className="table-header"
                    >
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      <CircularProgress style={{ color: "#f24464" }} />
                    </TableCell>
                  </TableRow>
                ) : rows.length > 0 ? (
                  rows
                    // .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((row) => (
                      <TableRow
                        hover
                        role="checkbox"
                        tabIndex={-1}
                        key={row.userid}
                      >
                        {columns.map((column) => {
                          const value = row[column.id];
                          return (
                            <TableCell
                              key={column.id}
                              align={column.align}
                              className="tableCelldata"
                              style={{
                                cursor:
                                  column.id === "profileuploaded" &&
                                  row.profileuploaded > 0
                                    ? "pointer"
                                    : "default",
                                textDecoration:
                                  column.id === "profileuploaded" &&
                                  row.profileuploaded > 0
                                    ? "underline"
                                    : "none",
                              }}
                              // onClick={() => {
                              //   if (
                              //     column.id === "profileuploaded" &&
                              //     row.profileuploaded > 0
                              //   ) {
                              //     onContentChange(() => (
                              //       <MatchProfileUpload
                              //         onContentChange={onContentChange}
                              //         userId={row.userid}
                              //         biodataSet={row.biodata_set}
                              //         matchmakerName={row.full_name}
                              //       />
                              //     ));
                              //   }
                              // }}
                              onClick={() => {
                                // if (
                                //   column.id === "profileuploaded" &&
                                //   row.profileuploaded > 0
                                // )
                                if (column.id === "profileuploaded") {
                                  // navigate("/matchmaker-profiles-uploaded", {
                                  //   state: {
                                  //     userId: row.originalId,
                                  //     biodataSet: row.biodata_set,
                                  //     matchmakerName: row.full_name,
                                  //     planType:row.plan,
                                  //     publicToken : row.public_token,
                                  //   },
                                  // });
                                  const data = {
                                    agentId: row.originalId,
                                    // biodataSet: row.biodata_set,
                                    matchmakerName: row.full_name,
                                    planType: row.plan,
                                    publicToken: row.public_token,
                                    email:row.email,    // used in razor pay payment
                                    mobile:row.mobile,  // used in razor pay payment
                                  };

                                
                                sessionStorage.setItem(
                                    "matchmakerProfileData",
                                    JSON.stringify(data)
                                  );

                                 
                                  navigate("/matchmaker-profiles-uploaded");
                                }
                              }}
                            >
                              {column.id === "userid" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                  }}
                                >
                                  <img
                                    src={row.profileImg}
                                    alt="profile"
                                    onError={(e) => {
                                      e.target.onerror = null; // Prevent infinite loop
                                      e.target.src = imagePlaceholder1;
                                    }}
                                    style={{
                                      width: 40,
                                      height: 40,
                                      borderRadius: "10px",
                                    }}
                                  />
                                  <span>{row.userid}</span>
                                </div>
                              ) : column.id === "plan" ?(
                                  row.planDisplay
                              )
                              
                              : column.id === "actions" ? (
                                <div>
                                  <FiEdit
                                    style={{ cursor: "pointer" }}
                                    // onClick={() => {
                                    //   if (typeof onContentChange === "function") {
                                    //     onContentChange(() => (
                                    //       <MatchEditProfile
                                    //         onContentChange={onContentChange}
                                    //         userId={row.originalId}
                                    //       />
                                    //     ));
                                    //   }
                                    // }}
                                    onClick={() =>
                                      navigate("/matchmaker-edit", {
                                        state: { id: row.originalId },
                                      })
                                    }
                                  />
                                  <MdOutlineDeleteOutline
                                    className="ms-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handleShow(row.originalId)}
                                  />
                                  <IoEyeOutline
                                    className="ms-3"
                                    style={{ cursor: "pointer" }}
                                    onClick={() =>
                                      navigate("/view-matchmaker-details", {
                                        state: { id: row.originalId },
                                      })
                                    }
                                  />
                                </div>
                              ) : (
                                value
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))
                ) : (
                  <TableRow>
                    <TableCell colSpan={columns.length} align="center">
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {/* <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        /> */}
        </Paper>
        {/* delete modal  */}
        <div>
          <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton style={{ borderBottom: "none" }}>
              {/* <Modal.Title>Delete</Modal.Title> */}
            </Modal.Header>
            <Modal.Body className="deleteText">
              Are you sure want to delete?
            </Modal.Body>
            <Modal.Footer style={{ borderTop: "none" }}>
              <button
                variant="secondary"
                onClick={handleClose}
                className="deleteModalBtnCancel"
              >
                Cancel
              </button>
              <button
                variant="primary"
                onClick={() => {
                  handleClose();
                  handleDeleteUser(deleteId);
                }}
                className="deleteModalBtnDelete"
              >
                Delete
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </>
  );
}
